import React from "react";
import { withNavBars } from "../../HOCs";
import AgreementDetails from "./agreementDetails";

class AgreementDetailsParent extends React.Component {
    render() {
        return <AgreementDetails />;
    }
}
const props = {
    boxShadow: false
}
export default withNavBars(AgreementDetailsParent, props);
